import { InnerView, SiteDeclaration } from "~/components";
import { FBProfile } from "~/.server/api";

interface TermsAndConditionsInnerViewProps {
  profile?: FBProfile;
}

export default function TermsAndConditionsInnerView({
  profile,
}: TermsAndConditionsInnerViewProps) {
  return (
    <InnerView
      id="terms"
      title="Terms and Conditions"
      showFooter={false}
      user={profile}
    >
      <div className="p-4 flex flex-col gap-2 text-text">
        <h1 className="text-xl font-bold text-primary">Introduction</h1>
        <p>
          Please read these Terms & Conditions carefully before using our
          websites and any online services provided by PWR Network Limited (“PWR
          Network Limited”, “we”, or “us” or “our”) that post a link to these
          Terms (the “Service”). By visiting this website, registering an
          account or otherwise using the Service, you agree to the then posted
          Terms, to be bound by them, and that you have read and understood
          them. You also acknowledge, agree and consent to our data practices as
          described in our Privacy Statement. You also understand that this is a
          fantasy entertainment Service and that (i) the profiles are fictional
          and your interactions will be with operators...
        </p>
        <h2>1. OWNERSHIP AND YOUR RIGHTS TO USE THE SERVICE AND CONTENT.</h2>
        <p>
          These Terms affect your legal rights, responsibilities and obligations
          and govern your use of the Service, are legally binding, limit PWR
          Network Limited’s liability to you and require you to indemnify us and
          to settle certain disputes through individual arbitration.
        </p>
        <h1 className="text-xl font-bold text-primary">Additional Terms</h1>
        <p>
          In some instances, additional or different terms, posted on the
          Service, apply to your use of certain parts of the Service
          (individually and collectively “Additional Terms”). To the extent
          there is a conflict between these Terms and any Additional Terms,
          these Terms will control unless the Additional Terms expressly state
          otherwise.
        </p>
        <h1 className="text-xl font-bold text-primary">
          Updates to these Terms and Additional Terms
        </h1>
        <p>
          We may prospectively change these Terms and Additional Terms by
          posting new or changed terms on the Service.
        </p>
        <h1 className="text-xl font-bold text-primary">Quick Links</h1>
        <ul>
          <li>Grants and Limitations of Rights</li>
          <li>
            We only grant you a limited revocable license to use the Service
            subject to rules and limitations.
          </li>
          <li>
            You grant us a broad license to the content you submit and to your
            profile. You retain ownership of and responsibility for your
            content. We have the right to manage our Service to keep its content
            appropriate.
          </li>
          <li>
            Your use of our Service is subject to various restrictions designed
            to protect the Service and users.
          </li>
        </ul>
        <h1 className="text-xl font-bold text-primary">
          Limitations on Your Remedies
        </h1>
        <ul>
          <li>As permitted by applicable law.</li>
          <li>
            We also disclaim most warranties and provide the Service “As Is”.
          </li>
          <li>Our liability is greatly limited.</li>
          <li>Your equitable or injunctive relief rights are limited.</li>
        </ul>
        <h1 className="text-xl font-bold text-primary">Dispute Resolution</h1>
        <ul>
          <li>
            As permitted by law, you agree to arbitrate disputes and waive jury
            trial and class actions.
          </li>
        </ul>
        <h1 className="text-xl font-bold text-primary">
          Availability of Service
        </h1>
        <ul>
          <li>
            We may change or discontinue our Service, or your right to access
            it, in whole or in part. More Our Service is intended for access
            from and use in the U.S.A
          </li>
        </ul>
        <h1 className="text-xl font-bold text-primary">A. Ownership</h1>
        <p>
          The Service and all of its content (“Content”), including all
          copyrights, patents, trademarks, service marks, trade names and all
          other intellectual property rights therein (“Intellectual Property”),
          are owned or controlled by PWR Network Limited, our licensors, and
          certain other third parties. All right, title, and interest in and to
          the Content and Intellectual Property available via the Service is the
          property of PWR Network Limited, our licensors or certain other third
          parties, and is protected by U.S. and international copyright,
          trademark, trade dress, patent and/or other Intellectual Property and
          unfair competition rights and laws to the fullest extent possible. PWR
          Network Limited owns the copyright in the selection, compilation,
          assembly, arrangement, and enhancement of the Content on the Service.
        </p>
        <h1 className="text-xl font-bold text-primary">
          B. Your Rights to Use the Service and Content.
        </h1>
        <p>
          (i) Your right to use the Service and Content is subject to your
          strict compliance with these Terms. Your right to access and use the
          Service and the Intellectual Property shall automatically terminate
          upon any violations. These rights are non-exclusive, limited, and
          revocable by us at any time in our sole discretion without advance
          notice or liability. As your right to access and use the Service and
          the content is personal to you, you may not assign nor transfer your
          right; any attempt to do so is void. You may, for your personal,
          non-commercial, lawful use only (collectively, the following are the
          “Company Licensed Elements”):
        </p>
        <p>
          (1) Display, view, use, and play the Content on a computer, mobile or
          other internet enabled or permitted device (“Device”) and/or print one
          copy of the Content (excluding source and object code in raw form or
          otherwise) as it is displayed to you;
        </p>
        <p>
          (2) Subject to any applicable Additional Terms, if the Service
          includes a “Send to Friend,” social media sharing or similar tool that
          allows you to initiate and send to one or more of your contacts a
          communication that includes content, or to post our content to
          third-party services or your own site or online service, and the tool
          is operational, use the tool to do so; provided, however, that you do
          not do so in any manner that violates applicable law or third-party
          rights or reflects negativity on us, and only send to recipients you
          have permission to contact;
        </p>
        <p>
          (3) Obtain a registered personal account (and/or related username and
          password) on the Service and interact with the Service in connection
          therewith;
        </p>
        <p>
          (4) Link to the Service from a website or other online service, so
          long as: (a) the links only incorporate text, and do not use any PWR
          Network Limited names, logos, or images, (b) the links and the content
          on your website do not suggest any affiliation with PWR Network
          Limited or cause any other confusion, and (c) the links and the
          content on your website do not portray PWR Network Limited or its
          products or services in a false, misleading, derogatory, or otherwise
          offensive manner, and do not contain content that is unlawful,
          offensive, obscene, lewd, lascivious, filthy, violent, threatening,
          harassing, or abusive, or that violate any right of any third-party or
          are otherwise objectionable to PWR Network Limited. PWR Network
          Limited reserves the right to suspend or prohibit linking to the
          Service for any reason, in its sole discretion, without advance notice
          or any liability of any kind to you or any third-party; and
        </p>
        <p>
          (5) Use any other functionality expressly provided by PWR Network
          Limited on or through the Service for use by users, subject to these
          Terms (including, without limitation, functionality to create and/or
          post User-Generated Content (as defined below)) and any applicable
          Additional Terms.
        </p>
        <h1 className="text-xl font-bold text-primary">
          C. Additional Terms for Credits and Virtual Items.
        </h1>
        <p>
          You can purchase Credits for the Service, From time to time, you may
          be permitted to purchase premium usage permissions (e.g., credits,
          points, and/or virtual currency) or optionally for virtual items
          (e.g., badges, avatars, emojis, graphic items, etc.) made available on
          the Service, all of which are, as permitted by applicable law, have no
          monetary value (i.e., are not a cash account or equivalent), and are
          purchases of only a limited, non-exclusive, revocable, non-assignable,
          non-descendible, personal, and non-transferable license to make use of
          those subject to the Additional Terms that are ascribed to them from
          time-to-time, which Additional Terms may change after purchase and are
          solely within our discretion. For instance, we may allow you to
          exchange Credits to send or receive messages or photos, chat or engage
          in other Services activities beyond what is offered at no charge. You
          understand and accept that the number of Credits to engage in certain
          activities is subject to change at any time so the number of Credits
          required to engage in a particular activity at the time of purchase
          may increase or decrease after purchase, and we may change or
          discontinue the activities available for Credit redemption at any
          time. Without limiting the foregoing, as permitted by applicable law,
          (i) these limited personal usage permissions are not subject to a
          community property interest, a descendible interest upon your death.
          escheat or any other property interest; (ii) any attempt to transfer,
          assign or otherwise sell or trade such Credits or other virtual items,
          regardless of manner or method, is null and void; and (iii) suspension
          or termination of your use of the Service results in the forfeit of
          your Credits and virtual items. As permitted by law, we are not
          responsible for repairing, or reissuing any credit or refund or any
          other sum, as a result of our modification of any Credits or virtual
          item, or for loss or damage due to error, or any other reason.
        </p>
        <h1 className="text-xl font-bold text-primary">D. Rights of Others.</h1>
        <p>
          In using the Service, you must respect the Intellectual Property and
          rights of others and PWR Network Limited. Your unauthorized use of
          Content may violate the rights of others and applicable laws, and may
          result in your civil and criminal liability. If you believe that your
          work has been infringed via the Service, see Section 5 below.
        </p>
        <h1 className="text-xl font-bold text-primary">
          E. Reservation of all Rights Not Granted as to Content and Service.
        </h1>
        <p>
          These Terms and any applicable Additional Terms include only narrow,
          limited grants of rights to use and access the Service and content. No
          right or license may be construed, under any legal theory, by
          implication, estoppel, industry custom, or otherwise. ALL RIGHTS NOT
          EXPRESSLY GRANTED TO YOU ARE RESERVED BY PWR Network Limited AND ITS
          LICENSORS AND OTHER THIRD PARTIES. Any unauthorized use of any Content
          or the Service for any purpose is prohibited.
        </p>
        <h1 className="text-xl font-bold text-primary">
          2. CONTENT YOU SUBMIT AND COMMUNITY USAGE RULES.
        </h1>
        <h1 className="text-xl font-bold text-primary">
          A. User-Generated Content.
        </h1>
        <p>
          (i) General. PWR Network Limited may now, or in the future, offer
          users of the Service the opportunity to create, build, post, upload,
          display, publish, distribute, transmit, broadcast, or otherwise make
          available on or submit through the Service, or on or in response to
          our pages or posts on any third-party platforms or in connection with
          any of our promotions by any media or manner, or otherwise submit to
          us (e.g., on our Facebook or other social media pages, in response to
          our tweets, through a sweepstakes or contest, or by otherwise sending
          it to us) (collectively, “submit”) messages, text, illustrations,
          files, images, graphics, photos, comments, responses, sounds, music,
          videos, information, content, ratings, reviews, data, questions,
          suggestions, personally identifiable information, or other information
          or materials and the ideas contained therein (collectively, but
          excluding Company Licensed Elements included therein, “User-Generated
          Content” or “UGC”). You may submit UGC through your profile, forums,
          blogs, message boards, social networking environments, content
          creation and posting tools, social communities, contact us tools,
          email, and other communications functionality. Except to the extent of
          the rights and license you grant in these Terms and, subject to any
          applicable Additional Terms, you retain whatever legally cognizable
          right, title, and interest that you have in your UGC.
        </p>
        <p>
          (ii) Non-Confidentiality of Your UGC. Except as otherwise described in
          the Service’s posted Privacy Statement, or any applicable Additional
          Terms, you agree that (A) your UGC will be treated as non-confidential
          and non-proprietary by us – regardless of whether you mark them
          “confidential,” “proprietary,” or the like – and will not be returned,
          and (B) to the maximum extent not prohibited by applicable law, PWR
          Network Limited does not assume any obligation of any kind to you or
          any third-party with respect to your UGC. Upon request, you will
          provide documentation necessary to authenticate rights to such content
          and verify your compliance with these Terms or any applicable
          Additional Terms. You acknowledge that the Internet and mobile
          communications may be insecure and subject to breaches of security;
          accordingly, you acknowledge and agree that your UGC is submitted at
          your own risk.
        </p>
        <p>
          In your communications with PWR Network Limited, please keep in mind
          that we do not seek any unsolicited ideas or materials for products or
          services, or even suggested improvements to products or services,
          including, without limitation, ideas, concepts, inventions, or designs
          for music, websites, apps, books, scripts, screenplays, motion
          pictures, television shows, theatrical productions, software or
          otherwise (collectively, “Unsolicited Ideas and Materials”). Any
          Unsolicited Ideas and Materials you submit are deemed UGC and licensed
          to us as set forth below. In addition, PWR Network Limited retains all
          of the rights held by members of the general public with regard to
          your Unsolicited Ideas and Materials. PWR Network Limited’s receipt of
          your Unsolicited Ideas and Materials is not an admission by PWR
          Network Limited of their novelty, priority, or originality, and it
          does not impair PWR Network Limited’s right to contest existing or
          future Intellectual Property rights relating to your Unsolicited Ideas
          and Materials.
        </p>
        <p>
          otherwise described in our Privacy Statement, you hereby grant PWR
          Network Limited, the non-exclusive, unrestricted, unconditional,
          unlimited, worldwide, irrevocable, perpetual, transferable and
          cost-free right and license to use, copy, record, distribute,
          reproduce, disclose, sell, re-sell, sublicense (through multiple
          levels), display, publicly perform, transmit, publish, broadcast,
          translate, make derivative works of, and otherwise use and exploit in
          any manner whatsoever, all or any portion of your UGC (and derivative
          works thereof), for any purpose whatsoever in all formats, on or
          through any means or medium now known or hereafter developed, and with
          any technology or devices now known or hereafter developed, and to
          advertise, market, and promote the same. Without limitation, the
          granted rights include the right to: (a) configure, host, index,
          cache, archive, store, digitize, compress, optimize, modify, reformat,
          edit, adapt, publish in searchable format, and remove such UGC and
          combine same with other materials, and (b) use any ideas, concepts,
          know-how, or techniques contained in any UGC for any purposes
          whatsoever, including developing, producing, and marketing products
          and/or services. You understand that in exercising such rights
          metadata, notices and content may be removed or altered, including
          copyright management information, and you consent thereto and
          represent and warrant you have all necessary authority to do so. In
          order to further effect the rights and license that you grant to PWR
          Network Limited to your UGC, you also, as permitted by applicable law,
          hereby grant to PWR Network Limited, and agree to grant to PWR Network
          Limited, the unconditional, perpetual, irrevocable right to use and
          exploit your name, persona, and likeness in connection with any UGC,
          without any obligation or remuneration to you. Except as prohibited by
          law, you hereby waive, and you agree to waive, any moral rights
          (including attribution and integrity) that you may have in any UGC,
          even if it is altered or changed in a manner not agreeable to you. To
          the extent not waivable, you irrevocably agree not to exercise such
          rights (if any) in a manner that interferes with any exercise of the
          granted rights. You understand that you will not receive any fees,
          sums, consideration, or remuneration for any of the rights granted in
          this Section 2.A(iii).
        </p>
        <p>
          (iv) PWR Network Limited’s Exclusive Right to Manage Our Service. PWR
          Network Limited may, but will not have any obligation to, review,
          monitor, display, post, store, maintain, accept, or otherwise make use
          of, any of your UGC, and PWR Network Limited may, in its sole
          discretion, reject, delete, move, re-format, remove or refuse to post
          or otherwise make use of UGC without notice or any liability to you or
          any third-party in connection with our operation of UGC venues in an
          appropriate manner, such as to enhance accessibility of UGC, address
          copyright infringement and protect Users from harmful UGC. Without
          limitation, we may, but do not commit to, do so to address content
          that comes to our attention that we believe is offensive, obscene,
          lewd, lascivious, filthy, violent, harassing, threatening, abusive,
          illegal or otherwise objectionable or inappropriate, or to enforce the
          rights of third parties or these Terms or any applicable Additional
          Terms. Such UGC submitted by you or others need not be maintained on
          the Service by us for any period of time, and you will not have the
          right, once submitted, to access, archive, maintain, change, remove,
          or otherwise use such UGC on the Service or elsewhere as provided for
          in the Privacy Statement.
        </p>
        <p>
          (v) Representations and Warranties Related to Your UGC. Each time you
          submit any UGC, you represent and warrant that you are at least the
          age of majority where you reside (eighteen (18) years of age in most
          states) and that, as to that UGC, (a) you are the sole author and
          owner of the Intellectual Property and other rights to the UGC, or you
          have a lawful right to submit the UGC and grant PWR Network Limited
          the rights to it that you are granting by these Terms and any
          applicable Additional Terms, all without any PWR Network Limited
          obligation to obtain consent of any third-party and without creating
          any obligation or liability of PWR Network Limited; (b) the UGC is
          accurate; (c) the UGC does not and, as to PWR Network Limited’s
          permitted uses and exploitation set forth in these Terms, will not
          infringe any Intellectual Property or other right of any third-party;
          and (d) the UGC will not violate these Terms or any applicable
          Additional Terms, or cause injury or harm to any person. (vi)
          Enforcement. PWR Network Limited has no obligation to monitor or
          enforce your Intellectual Property rights to your UGC, but you grant
          us the right to protect and enforce our rights to your UGC, including
          initiating actions in your name and on your behalf (at PWR Network
          Limited’s cost and expense, to which you hereby consent and
          irrevocably appoint PWR Network Limited as your attorney-in-fact, with
          the power of substitution and delegation, which appointment is coupled
          with an interest).
        </p>
        <h1 className="text-xl font-bold text-primary">
          B. Community Usage Rules.
        </h1>
        <p>
          As a user of the Service, these Community Usage Rules (“Rules”) are
          here to help you understand the conduct that is expected of members of
          the Service’s online communities (“Communities”).
        </p>
        <p>
          (i) Nature of Rules. Your participation in the Communities is subject
          to all of the Terms, including these Rules:
        </p>
        <ul>
          <li>
            Your UGC. All of your UGC either must be original with you or you
            must have all necessary rights in it from third parties in order to
            permit you to comply with these Terms and any applicable Additional
            Terms. Your UGC should not contain any visible logos, phrases, or
            trademarks that belong to third parties. Do not use any UGC that
            belongs to other people and pass it off as your own; this includes
            any content that you might have found elsewhere on the Internet. If
            anyone contributes to your UGC or has any rights to your UGC, or if
            anyone appears or is referred to in the UGC, then you must also have
            their permission to submit such UGC to PWR Network Limited. (For
            example, if someone has taken a picture of you and your friend, and
            you submit that photo to PWR Network Limited as your UGC, then you
            must obtain your friend’s and the photographer’s permission to do
            so.)
          </li>
          <li>
            Speaking of Photos: No Pictures, Videos, or Images of Anyone Other
            Than You and Your Friends and Family. If you choose to submit photos
            to the Service or include other images of real people, then make
            sure they are of you or of you and someone you know – and only if
            you have their express permission to submit it.
          </li>
          <li>
            Act Appropriately. All of your Service activities must be venue
            appropriate, as determined by us. Be respectful of others’ opinions
            and comments so we can continue to build Communities for everyone to
            enjoy. If you think your UGC might offend someone or be embarrassing
            to someone, then chances are it probably will and it doesn’t belong
            on the Service. Cursing, harassing, stalking, insulting comments,
            personal attacks, gossip, and similar actions are prohibited. Your
            UGC must not threaten, abuse, or harm others, and it must not
            include any negative comments that are connected to race, national
            origin, gender, sexual orientation, religion, or handicap. Your UGC
            must not be defamatory, slanderous, obscene or otherwise illegal.
            Your UGC must not exploit children under the age of 18.
          </li>
          <li>
            Do Not Use for Commercial or Political Purposes. Your UGC must not
            advertise or promote a product or service or other commercial
            activity, or a politician, public servant, or law.
          </li>
          <li>
            Do Not Use to Solicit or Send Unwanted Communications. Do not
            harvest or collect email addresses or other contact information of
            others from the Service by electronic or other means for the
            purposes of sending unsolicited emails or other unsolicited
            communications. Do not solicit personal information from anyone or
            solicit passwords or personally identifying information for
            commercial or unlawful purposes. This also includes not uploading,
            posting, transmitting, sharing or otherwise making available any
            unsolicited or unauthorized advertising, solicitations, promotional
            materials, “junk mail,” “spam,” “chain letters,” “pyramid schemes,”
            or any other form of solicitation.
          </li>
          <li>
            Do Not Use for Inappropriate Purposes. Your UGC must not promote any
            infringing, illegal, or other similarly inappropriate activity.
          </li>
          <li>
            Be Honest and Do Not Misrepresent Yourself or Your UGC. Do not
            impersonate any other person, user, or company, and do not submit
            UGC that you believe may be false, fraudulent, deceptive,
            inaccurate, or misleading, or that misrepresents your identity or
            affiliation with a person or company. In the event you receive
            anything in consideration from us with respect to your UGC (e.g.,
            coupons, sweepstakes entries, etc.) you represent you will include
            disclosure of the receipt of this consideration clearly and
            conspicuously as part of the UGC and include any other disclosures
            we may require.
          </li>
          <li>
            Others Can See. We hope that you will use the Communities to
            exchange information and content and have venue appropriate
            discussions with other members. However, please remember that the
            Communities are public or semi-public and UGC that you submit on the
            Service within a Community may be accessible and viewable by other
            users. Do not submit personally identifying information (e.g., first
            and last name together, password, phone number, address, credit card
            number, medical information, email address, or other personally
            identifiable information or contact information) on the Communities
            and take care when otherwise disclosing this type of information to
            others.
          </li>
          <li>
            Don’t Share Other People’s Personal Information. Your UGC should not
            reveal another person’s address, phone number, email address, social
            security number, credit card number, medical information, financial
            information, or any other information that may be used to track,
            contact, or impersonate that individual, unless, and in the form and
            by the method, specifically requested by PWR Network Limited (e.g.,
            an email address to send an email invite to a friend).
          </li>
          <li>
            Don’t Damage the Service or Anyone’s Computers or Other Devices.
            Your UGC must not submit viruses, Trojan horses, spyware, or any
            other technologies or malicious code that could impact the operation
            of the Service or any computer or other Device.
          </li>
        </ul>
        <p>
          If you submit UGC that PWR Network Limited reasonably believes
          violates these Rules, then we may take any legally available action
          that we deem appropriate, in our sole discretion. However, we are not
          obligated to take any action not required by applicable law. We may
          require, at any time, proof of the permissions referred to above in a
          form acceptable to us. Failure to provide such proof may lead to,
          among other things, the UGC in question being removed from the
          Service.
        </p>
        <p>
          (ii) Your Interactions With Other Users; Disputes. You are solely
          responsible for your interaction with other users of the Service,
          whether online or offline. We do not conduct any background or
          criminal record check or other investigation of users, some of which
          may be sex offenders, fraudsters or otherwise unsavory and may intend
          you harm. We are not responsible or liable for the conduct or content
          of any user. We reserve the right, but have no obligation, to monitor
          or become involved in disputes between you and other users. Exercise
          common sense and your best judgment in your interactions with others
          (e.g., when you submit any personal or other information) and in all
          of your other online activities.
        </p>
        <h1 className="text-xl font-bold text-primary">
          C. Appropriate Content and Alerting Us of Violations.
        </h1>
        <p>
          We expect UGC to be appropriate for a mature audience and consistent
          with our Community Rules, but do not undertake to monitor it, and you
          consent to potentially encountering content you find offensive or
          inappropriate. We may include venue and content rules as Additional
          Terms. If you discover any content that violates these Terms then you
          may report it here. For alleged infringements of Intellectual Property
          rights, see Section 5.
        </p>
        <h1 className="text-xl font-bold text-primary">
          3. SERVICE AND CONTENT USE RESTRICTIONS.
        </h1>
        <h1 className="text-xl font-bold text-primary">
          A. Service Use Restrictions.
        </h1>
        <p>
          You agree that you will not: (i) use the Service for any political or
          commercial purpose (including, without limitation, for purposes of
          advertising, soliciting funds, collecting product prices, and selling
          products); (ii) use any meta tags or any other “hidden text” utilizing
          any Intellectual Property; (iii) engage in any activities through or
          in connection with the Service that seek to attempt to or do harm any
          individuals or entities or are unlawful, offensive, filthy, violent,
          threatening, harassing, or abusive, or that violate any right of any
          third-party, or are otherwise objectionable to PWR Network Limited;
          (iv) decompile, disassemble, reverse engineer, or attempt to
          reconstruct, identify, or discover any source code, underlying ideas,
          underlying user interface techniques, or algorithms of the Service by
          any means whatsoever or modify any Service source or object code or
          any Software or other products, services, or processes accessible
          through any portion of the Service; (v) engage in any activity that
          interferes with a user’s access to the Service or the proper operation
          of the Service, or otherwise causes harm to the Service, PWR Network
          Limited, or other users of the Service; (vi) interfere with or
          circumvent any security feature (including any digital rights
          management mechanism, device or other content protection or access
          control measure) of the Service or any feature that restricts or
          enforces limitations on use of or access to the Service, the Content,
          or the UGC; (vii) harvest or otherwise collect or store any
          information (including personally identifiable information about other
          users of the Service, including email addresses, without the express
          consent of such users); (viii) attempt to gain unauthorized access to
          the Service, other computer systems or networks connected to the
          Service, through password mining or any other means; or (ix) otherwise
          violate these Terms or any applicable Additional Terms.
        </p>
        <h1 className="text-xl font-bold text-primary">
          B. Content Use Restrictions.
        </h1>
        <p>
          You also agree that, in using the Service, you: (i) will not monitor,
          gather, copy, or distribute the Content (except as may be a result of
          standard search engine activity or use of a standard browser) on the
          Service by using any robot, rover, “bot”, spider, scraper, crawler,
          spyware, engine, device, software, extraction tool, or any other
          automatic device, utility, or manual process of any kind; (ii) will
          not frame or utilize framing techniques to enclose any such content
          (including any images, text, or page layout); (iii) will keep intact
          all Trademark, copyright, and other Intellectual Property and other
          notices contained in such content; (iv) will not use such content in a
          manner that suggests an unauthorized association with any of our or
          our licensors’ products, services, or brands; (v) will not make any
          modifications to such content (other than to the extent of your
          specifically permitted use of the Company Licensed Elements, if
          applicable); (vi) will not copy, modify, reproduce, archive, sell,
          lease, rent, exchange, create derivative works from, publish by hard
          copy or electronic means, publicly perform, display, disseminate,
          distribute, broadcast, retransmit, circulate or transfer to any
          third-party or on any third-party application or website, or otherwise
          use or exploit such content in any way for any purpose except as
          specifically permitted by these Terms or any applicable Additional
          Terms or with the prior written consent of an officer of PWR Network
          Limited or, in the case of content from a licensor, the owner of the
          content; and (vii) will not insert any code or product to manipulate
          such content in any way that adversely affects any user experience or
          the Service.
        </p>
        <h1 className="text-xl font-bold text-primary">
          C. Availability of Service and Content.
        </h1>
        <p>
          PWR Network Limited, in its sole discretion without advance notice or
          liability, may immediately suspend or terminate the availability of
          the Service and/or Content (and any elements and features of them), in
          whole or in part, for any reason, in PWR Network Limited’s sole
          discretion, and without advance notice or liability.
        </p>
        <h1 className="text-xl font-bold text-primary">
          4. ACCOUNTS, PROFILES, AND SOCIAL FEATURES.
        </h1>
        <p>
          A. In order to access or use some (or potentially all) of the features
          on the Service, you must first register through our online
          registration process at flirtybum.com. The Service’s practices
          governing any resulting collection use, disclosure and management of
          your personal information are disclosed in its Privacy Statement. If
          you are under the age of eighteen (18), or otherwise under the age of
          majority where you reside (19 or 21 in some states) then you are not
          permitted to register as a user, create a Profile Page or otherwise
          use the Service or submit personal information to us. If you register
          with us or create an account, you are solely responsible and liable
          for the security and confidentiality of your access credentials and
          for restricting access to your Device and for all activity under your
          account. Usernames and passwords must be personal and unique that do
          not violate the rights of any person or entity and is not offensive.
          We may reject the use of any password, username, or email address for
          any reason in our sole discretion. You are solely responsible for your
          registration information and for updating and maintaining it. You will
          immediately notify us here of any unauthorized use of your account,
          password, or username, or any other breach of security, but will
          remain responsible for any unauthorized use thereafter. You will not
          sell, transfer, or assign your account or any account rights.
        </p>
        <p>
          B. Accounts may only be set up by the individual that is the subject
          of the account and who is at least eighteen (18) years of age, and the
          age of majority where you reside if that is over 18, or older.
        </p>
        <p>
          <strong>C. Profiles.</strong> We may from time-to-time permit you to
          set up private, semi-private and/or public profile pages (“Profile
          Page(s)”) that allows you to provide and/or display information about
          you. Your Profile Page may not include any form of prohibited
          User-Generated Content, as outlined in Section 2.A above and in our
          Community Usage Rules. Without limiting the foregoing, Profile Pages
          may not include content that you are attempting to sell through the
          Service, and cannot be used to conduct commercial activities,
          including, but not limited to, transactions, advertising, fundraising,
          contests or other promotions absent our prior written consent. We may
          offer you the ability to set preferences relating to your profile or
          Service activities, but settings may not become effective immediately
          or be error free, and options may change from time-to-time. We assume
          no responsibility or liability for users’ Profile material. Profile
          Pages may only be set up by an authorized representative of the
          individual that is the subject of the Profile Page. Such resolution
          may include, without limitation, deleting or disabling access to
          Profile Pages, or any portion thereof, at any time without notice.
        </p>
        <p>
          Profiles marked with a heart icon: are fictional entertainers’
          profiles rather than members profiles, physical contact with these
          profiles is not possible.
        </p>
        <p>
          <strong>D. Email Messages.</strong> You may cancel or modify our email
          marketing communications you receive from us by following the
          instructions contained within our promotional emails. This will not
          affect subsequent subscriptions and if your opt-out is limited to
          certain types of emails the opt-out will be so limited. Please note
          that we reserve the right to send you certain communications relating
          to your account or use of our Service, such as administrative and
          service announcements and these transactional account messages may be
          unaffected if you choose to opt-out from receiving our marketing
          communications.
        </p>
        <h1 className="text-xl font-bold text-primary">
          5. PROCEDURE FOR ALLEGING COPYRIGHT INFRINGEMENT.
        </h1>
        <p>
          If you are a copyright owner who would like to send us a notice
          pursuant to the Digital Millennium Copyright Act (“DMCA”) to identify
          content or material posted on the Service that is infringing that you
          would like removed from our Service, or if you are a user whose work
          has been removed in response to such a notice of infringement and
          would like to file a DMCA counter-notice, you may submit such notice
          to us by following the instructions here.
        </p>
        <h1 className="text-xl font-bold text-primary">A. DMCA Notice.</h1>
        <p>
          PWR Network Limited. asks our users to respect the intellectual
          property rights of others. It is our Statement to respond
          appropriately to clear notices of alleged copyright infringement, as
          set forth more fully below. In our sole discretion, we may remove
          content that may be infringing on another person’s intellectual
          property rights with or without notice to the potential infringer. In
          accordance with the U.S. Digital Millennium Copyright Act (“DMCA”) and
          other applicable law, PWR Network Limited has adopted a policy of
          terminating, in appropriate circumstances, users who are deemed to be
          repeat infringers.
        </p>
        <p>
          B. If we remove or disable access in response to a DMCA Copyright
          Infringement Notice, we will make a good faith attempt to contact the
          owner or administrator of the affected content so that they may make a
          counter-notification. If you own a copyright in a work (or represent
          such a copyright owner) and believe that your (or such owner’s)
          copyright in that work has been infringed by an improper posting or
          distribution of it via the Service, then you may send us a written
          notice that includes all of the following: <br />
          (i) a legend or subject line that says: “DMCA Copyright Infringement
          Notice”; <br /> (ii) a description of the copyrighted work that you
          claim has been infringed or, if multiple copyrighted works are covered
          by a single notification, a representative list of such works; <br />
          (iii) a description of where the material that you claim is infringing
          or is the subject of infringing activity is located that is reasonably
          sufficient to permit us to locate the material (please include the
          full URL of the page(s) on the Service on which the material appears);{" "}
          <br /> (iv) your full name, address, telephone number, and email
          address; <br /> (v) a statement by you that you have a good faith
          belief that use of the material in the manner complained of is not
          authorized by the copyright owner, its agent, or the law; <br /> (vi)
          a statement by you, made under penalty of perjury, that all the
          information in your notice is accurate, and that you are the copyright
          owner (or, if you are not the copyright owner, then your statement
          must indicate that you are authorized to act on the behalf of the
          owner of an exclusive right that is allegedly infringed); and <br />{" "}
          (vii) your electronic or physical signature.
        </p>
        <p>
          COMPANY will only respond to DMCA Notices that it receives by mail or
          email at the addresses below: By Mail: Agias Zonis & Thessalonikis,
          Nicolaou Pantadromos Center, 5th floor, Flat/Office 503B, Block B,
          3026 Limassol, Cyprus By Email: hello@flirtybum.com
        </p>
        <p>
          It is often difficult to determine if your copyright has been
          infringed. PWR Network Limited may elect to not respond to DMCA
          Notices that do not substantially comply with all of the foregoing
          requirements, and PWR Network Limited may elect to remove allegedly
          infringing material that comes to its attention via notices that do
          not substantially comply with the DMCA. Please note that the DMCA
          provides that any person who knowingly materially misrepresents that
          material or activity is infringing may be subject to liability.
        </p>
        <p>
          We may send the information that you provide in your notice to the
          person who provided the allegedly infringing work. That person may
          elect to send us a DMCA Counter-Notification.
        </p>
        <p>
          Without limiting PWR Network Limited’s other rights, PWR Network
          Limited may, in appropriate circumstances, terminate a repeat
          infringer’s access to the Service and any other website owned or
          operated by PWR Network Limited.
        </p>
        <h1 className="text-xl font-bold text-primary">
          6. NOTICES, QUESTIONS AND CUSTOMER SERVICE.
        </h1>
        <p>
          You agree that we may give you notices or otherwise respond to you by
          mail or to your email (if we have it on file) or in any other manner
          reasonably elected by us. All legal notices to us must be sent to:
          Agias Zonis & Thessalonikis, Nicolaou Pantadromos Center, 5th floor,
          Flat/Office 503B, Block B, 3026 Limassol, Cyprus.
        </p>
        <h1 className="text-xl font-bold text-primary">
          7. PRODUCT SPECIFICATIONS; PRICING; TYPOGRAPHICAL ERRORS.
        </h1>
        <p>
          We strive to accurately describe our products or services offered on
          the Service; however, we do not warrant that such specifications,
          pricing, or other content on the Service is complete, accurate,
          reliable, current, or error-free. As permitted by applicable law, PWR
          Network Limited shall have the right to refuse or cancel any orders in
          its sole discretion. Your orders are offers to purchase subject to our
          acceptance, which we may reject or cancel subject to refund. If we
          charged your credit or other account prior to rejection or
          cancellation, we will reissue credit to your account. Additional Terms
          may apply.
        </p>
        <h1 className="text-xl font-bold text-primary">
          8. ARBITRATION AND DISPUTE TERMS.
        </h1>
        <h1 className="text-xl font-bold text-primary">
          A. Forum Selection/Jurisdiction.
        </h1>
        <p>
          Jurisdiction and venue for any controversy, allegation, or claim
          arising out of or relating to the Service, the Content, your UGC,
          these Terms, or any applicable Additional Terms, (collectively,
          “Dispute”) shall be in Cyprus. Each party submits to personal
          jurisdiction and venue in Amsterdam for any and all purposes.
        </p>
        <h1 className="text-xl font-bold text-primary">
          B. Pre-Arbitration Notification.
        </h1>
        <p>
          PWR Network Limited and you agree that it would be advantageous to
          discuss and hopefully resolve any Disputes before formal proceedings
          are initiated; provided, however, that PWR Network Limited need not do
          so in circumstances where its claims of Intellectual Property rights
          are concerned (“IP Disputes,” with all other disputes referred to as
          “General Disputes”). The party making a claim – whether you or PWR
          Network Limited – shall send a letter to the other side briefly
          summarizing the claim and the request for relief. If PWR Network
          Limited is making a claim, the letter shall be sent, via email, to the
          email address listed in your account, if applicable. If no such
          information exists or if such information is not current, then we have
          no notification or delay obligations under this Section 8.B. If you
          are making a claim, the letter shall be sent to PWR Network Limited,
          Agias Zonis & Thessalonikis Nicolaou Pantadromos Center, 5th floor,
          Flat/Office 503B, Block B, 3026 Limassol, Cyprus s (Attn: General
          Counsel). If the Dispute is not resolved within sixty (60) days after
          notification, the claimant may proceed to initiate proceedings as set
          forth in this Section 8. Either you or PWR Network Limited, however,
          may seek provisional remedies (such as preliminary injunctive relief,
          subject to Section 8.D) before the expiration of this sixty (60)-day
          period.
        </p>
        <h1 className="text-xl font-bold text-primary">
          C. Arbitration of Claims.
        </h1>
        <p>
          All actions or proceedings arising in connection with, touching upon
          or relating to any Dispute, or the scope of the provisions of this
          Section, shall be submitted to JAMS (www.jamsadr.com) for final and
          binding arbitration under its Comprehensive Arbitration Rules and
          Procedures if the matter in dispute is over €250,000 or under its
          Streamlined Arbitration Rules and Procedures if the matter in dispute
          is €250,000 or less, to be held in Cyprus, before a single arbitrator
          in accordance with California Code of Civil Procedure §§ 1280 et seq.
          If the matter in dispute is between PWR Network Limited and a
          consumer, the matter shall be submitted to JAMS in accordance with its
          Policy on Consumer Arbitration Pursuant to Pre-Dispute Clauses Minimum
          Standards of Procedural Fairness. The arbitrator shall be selected by
          mutual agreement of the parties or, if the parties cannot agree, then
          by striking from a list of arbitrators supplied by JAMS. We may have
          the right to pay the JAMS fees if required for arbitration to be
          enforceable. The arbitration shall be a confidential proceeding,
          closed to the general public; provided, however, that a party may
          disclose information relating to the arbitration proceedings to its
          and its affiliates’ lawyers, insurance providers, auditors and other
          professional advisers. The fact that there is a dispute between the
          parties that is the subject of arbitration shall be confidential to
          the same extent. The arbitrator shall issue a written opinion stating
          the essential findings and conclusions upon which the arbitrator’s
          award is based. Neither party shall be entitled or permitted to
          commence or maintain any action in a court of law with respect to any
          matter in dispute until such matter shall have been submitted to
          arbitration as herein provided and then only for the enforcement of
          the arbitrator’s award; provided, however, that prior to the
          appointment of the arbitrator or for remedies beyond the jurisdiction
          of an arbitrator, at any time, either party may seek pendente lite
          relief (subject to the provisions of these Terms waiving or limiting
          that relief) in a court of competent jurisdiction in Cyprus or, if
          sought by PWR Network Limited, such other court that may have
          jurisdiction over you, without thereby waiving its right to
          arbitration of the dispute or controversy under this Section; provided
          further, however, that the losing party shall have fifteen (15)
          business days after the issuance of the arbitrator’s decision to fully
          comply with such decision, after which the prevailing party may
          enforce such decision by a petition to the court or, in the case of
          you, such other court having jurisdiction over you, which may be made
          ex parte, for confirmation and enforcement of the award.
        </p>
        <h1 className="text-xl font-bold text-primary">
          D. Limitation on Injunctive Relief.
        </h1>
        <p>
          AS PERMITTED BY APPLICABLE LAW, IF YOU CLAIM THAT YOU HAVE INCURRED
          ANY LOSS, DAMAGES, OR INJURIES IN CONNECTION WITH YOUR USE OF THE
          SERVICE, THEN THE LOSSES, DAMAGES, AND INJURIES WILL NOT BE DEEMED
          IRREPARABLE OR SUFFICIENT TO ENTITLE YOU TO AN INJUNCTION OR TO OTHER
          EQUITABLE RELIEF OF ANY KIND. THIS MEANS (WITHOUT LIMITATION) THAT, IN
          CONNECTION WITH YOUR CLAIM, YOU AGREE THAT YOU WILL NOT SEEK, AND THAT
          YOU WILL NOT BE PERMITTED TO OBTAIN, ANY COURT OR OTHER ACTION THAT
          MAY INTERFERE WITH OR PREVENT THE DEVELOPMENT OR EXPLOITATION OF ANY
          WEBSITE, APPLICATION, CONTENT, UGC, PRODUCT, SERVICE, OR INTELLECTUAL
          PROPERTY OWNED, LICENSED, USED, OR CONTROLLED BY ANY COMPANY PARTY
          (DEFINED BELOW) (INCLUDING YOUR LICENSED UGC) OR A LICENSOR OF ANY
          COMPANY PARTY.
        </p>
        <h1 className="text-xl font-bold text-primary">E. Governing Law.</h1>
        <p>
          These Terms and any applicable Additional Terms, General Disputes and
          IP Disputes, and any other claim brought by you against PWR Network
          Limited or by PWR Network Limited against you pursuant to this Section
          8, or otherwise related to the Service, Content, Company Licensed
          Elements, UGC or other PWR Network Limited products or services, will
          be governed by, construed, and resolved in accordance with, the laws
          of Cyprus, without regard to its conflicts of law provisions that
          might apply the laws of another jurisdiction, unless the applicable
          laws of your jurisdiction of residence require that the laws of such
          jurisdiction govern, in which case the laws of such jurisdiction are
          to govern. This Section 8 shall be governed solely by the Federal
          Arbitration Act, 9 U.S.C. §1, et seq., and not by the law of any
          state, and is enforceable pursuant to its terms on a self-executing
          basis. You and PWR Network Limited agree that we intend that this
          Section 8 satisfies the “writing” requirement of the Federal
          Arbitration Act. This Section 8 can only be amended by mutual
          agreement. Either party may seek enforcement of this Section 8 in any
          court of competent jurisdiction. The arbitrator shall determine any
          and all challenges to the arbitrability of a claim.
        </p>
        <h1 className="text-xl font-bold text-primary">
          F. Class Action Waiver.
        </h1>
        <p>
          As permitted by applicable law, both you and PWR Network Limited waive
          the right to bring any Dispute as a class, consolidated,
          representative, collective, or private attorney general action, or to
          participate in a class, consolidated, representative, collective, or
          private attorney general action regarding any Dispute brought by
          anyone else. Notwithstanding any provision in the JAMS Comprehensive
          Arbitration Rules and Procedures to the contrary, the arbitrator shall
          not have the authority or any jurisdiction to hear the arbitration as
          a class, consolidated, representative, or private attorney general
          action or to consolidate, join, or otherwise combine the Disputes of
          different persons into one proceeding. Notwithstanding the arbitration
          provision set forth above, if the provision regarding waiver of class,
          collective, representative, and private attorney general claims of
          this Section 8 is found to be void or otherwise unenforceable, any
          such class, collective, representative, or private attorney general
          claims must be heard and determined through an appropriate court
          proceeding, and not in arbitration.
        </p>
        <h1 className="text-xl font-bold text-primary">G. Jury Waiver.</h1>
        <p>
          AS PERMITTED BY APPLICABLE LAW, THE PARTIES HEREBY WAIVE THEIR RIGHT
          TO JURY TRIAL WITH RESPECT TO ALL CLAIMS AND ISSUES ARISING UNDER, IN
          CONNECTION WITH, TOUCHING UPON OR RELATING TO THESE TERMS, THE BREACH
          THEREOF AND/OR THE SCOPE OF THE PROVISIONS OF THIS SECTION, WHETHER
          SOUNDING IN CONTRACT OR TORT, AND INCLUDING ANY CLAIM FOR FRAUDULENT
          INDUCEMENT THEREOF.
        </p>
        <h1 className="text-xl font-bold text-primary">
          H. Small Claims Matters.
        </h1>
        <p>
          Notwithstanding the foregoing, either of us may bring qualifying claim
          of General Dispute (but not IP Disputes) in small claims court,
          subject to Section 8.F.
        </p>
        <p>
          I. The provisions of this Section 8 shall supersede any inconsistent
          provisions of any prior agreement between the parties. This Section 8
          shall remain in full force and effect notwithstanding any termination
          of your use of the Service or these Terms.
        </p>
        <h1 className="text-xl font-bold text-primary">
          9. DISCLAIMER OF REPRESENTATIONS AND WARRANTIES.
        </h1>
        <p>
          A. THE WEBSITE, THE SERVICES AND THE CONTENT ARE BEING PROVIDED FOR
          ENTERTAINMENT PURPOSES ONLY AND ARE NOT INTENDED TO BE USED FOR
          ESTABLISHING MEETINGS WITH OTHER USERS.
        </p>
        <p>
          B. AS PERMITTED BY APPLICABLE LAW, YOUR ACCESS TO AND USE OF THE
          SERVICE IS AT YOUR SOLE RISK AND THE SERVICE IS PROVIDED ON AN “AS
          IS”, “AS AVAILABLE”, AND “WITH ALL FAULTS” BASIS. To the fullest
          extent permissible by applicable law, PWR Network Limited and their
          direct and indirect parents, subsidiaries, affiliates, and each of
          their respective employees, directors, members, managers,
          shareholders, agents, vendors, licensors, licensees, contractors,
          customers, successors, and assigns (collectively, “Company Parties”)
          hereby disclaim and make no representations, warranties, endorsements,
          or promises, express or implied, in connection with, or otherwise
          directly or indirectly related to, without limitation, the Service,
          Content, Company Licensed Elements, UGC or other PWR Network Limited
          products or services, except as set forth in subsection D, below.
        </p>
        <p>
          C. EXCEPT FOR ANY SPECIFIC WARRANTIES PROVIDED HEREIN, OR IN
          APPLICABLE ADDITIONAL TERMS, OR AS OTHERWISE REQUIRED BY APPLICABLE
          LAW, COMPANY PARTIES HEREBY FURTHER DISCLAIM ALL WARRANTIES, EXPRESS
          OR IMPLIED, INCLUDING THE WARRANTIES OF MERCHANTABILITY, FITNESS FOR A
          PARTICULAR PURPOSE, NON-INFRINGEMENT OR MISAPPROPRIATION OF
          INTELLECTUAL PROPERTY RIGHTS OF THIRD PARTIES, TITLE, CUSTOM, TRADE,
          QUIET ENJOYMENT, SYSTEM INTEGRATION AND FREEDOM FROM COMPUTER VIRUS.
        </p>
        <p>
          D. NOTWITHSTANDING THE FOREGOING, THIS SECTION DOES NOT EXPAND OR
          LIMIT (I) COMPANY PARTIES’ LIABILITY FOR PERSONAL INJURY TO YOU CAUSED
          BY COMPANY PARTIES TO THE EXTENT NOT WAIVABLE OR CANNOT BE LIMITED
          UNDER APPLICABLE LAW; OR (II) ANY CAUSE OF ACTION YOU MAY HAVE AGAINST
          COMPANY PARTIES THAT IS NOT WAIVABLE OR CANNOT BE LIMITED UNDER
          APPLICABLE LAW.
        </p>
        <h1 className="text-xl font-bold text-primary">
          10. LIMITATION OF LIABILITY.
        </h1>
        <p>
          A. AS PERMITTED BY APPLICABLE LAW, UNDER NO CIRCUMSTANCES WILL ANY
          COMPANY PARTIES BE RESPONSIBLE OR LIABLE FOR ANY LOSS OR DAMAGES OF
          ANY KIND, including personal injury or death or for any direct,
          indirect, economic, exemplary, special, punitive, incidental, or
          consequential losses or damages of any kind, including without
          limitation loss of profits, in connection with, or otherwise directly
          or indirectly related to, without limitation, the Service, Content,
          Company Licensed Elements, UGC or other PWR Network Limited products
          or services, except, to the extent not waivable under applicable law.
        </p>
        <p>
          B. The foregoing limitations of liability will apply even if any of
          the events or circumstances were foreseeable and even if Company
          Parties were advised of or should have known of the possibility of
          such losses or damages, regardless of whether you bring an action
          based in contract, negligence, strict liability, or tort (including
          whether caused, in whole or in part, by negligence, acts of god,
          telecommunications failure, or destruction of the Service).
        </p>
        <p>
          C. AS PERMITTED BY APPLICABLE LAW, IN NO EVENT WILL COMPANY PARTIES’
          TOTAL LIABILITY TO YOU, FOR ALL POSSIBLE DAMAGES, LOSSES, AND CAUSES
          OF ACTION IN CONNECTION WITH YOUR ACCESS TO AND USE OF THE SERVICE AND
          YOUR RIGHTS UNDER THESE TERMS, EXCEED AN AMOUNT EQUAL TO THE AMOUNT
          YOU HAVE PAID COMPANY IN CONNECTION WITH THE TRANSACTION(S) THAT
          UNDERLIE THE CLAIM(S).
        </p>
        <p>
          D. PWR Network Limited IS NOT RESPONSIBLE FOR YOUR USE OF THE SERVICES
          OR FOR THE ACTIONS OF OTHER USERS WITH WHOM YOU MAY EXCHANGE
          INFORMATION OR HAVE CONTACT. PWR Network Limited DOES NOT CONDUCT
          CRIMINAL BACKGROUND SCREENINGS OF ITS USERS. PWR Network Limited DOES
          NOT VERIFY THE INFORMATION PROVIDED BY USERS WITH RESPECT TO USERS’
          HEALTH, PHYSICAL CONDITION, OR OTHERWISE.
        </p>
        <p>
          E. NOTWITHSTANDING THE FOREGOING, THIS SECTION DOES NOT EXPAND OR
          LIMIT (I) COMPANY PARTIES’ LIABILITY FOR PERSONAL INJURY TO YOU CAUSED
          BY COMPANY PARTIES TO THE EXTENT NOT WAIVABLE OR CANNOT BE LIMITED
          UNDER APPLICABLE LAW; OR (II) ANY CAUSE OF ACTION YOU MAY HAVE AGAINST
          COMPANY PARTIES THAT IS NOT WAIVABLE OR CANNOT BE LIMITED UNDER
          APPLICABLE LAW.
        </p>
        <p>
          F. Nothing in these Terms shall operate to exclude or limit our
          liability for death or personal injury caused by negligence, fraud or
          fraudulent concealment; or any other liability which cannot be
          excluded or limited under applicable law.
        </p>
        <h1 className="text-xl font-bold text-primary">
          11. UPDATES TO TERMS.
        </h1>
        <p>
          It is your responsibility to review the posted Terms and any
          applicable Additional Terms each time you use the Service (at least
          prior to each transaction or submission). EACH TIME YOU SIGN IN TO OR
          OTHERWISE USE THE SERVICE YOU ARE ENTERING INTO A NEW AGREEMENT WITH
          US ON THE THEN APPLICABLE TERMS AND CONDITIONS AND YOU AGREE THAT WE
          MAY NOTIFY YOU OF NEW TERMS BY POSTING THEM ON THE SERVICE (OR IN ANY
          OTHER REASONABLE MANNER OF NOTICE WHICH WE ELECT), AND THAT YOUR USE
          OF THE SERVICE AFTER SUCH NOTICE CONSTITUTES YOUR GOING FORWARD
          AGREEMENT TO THE NEW TERMS FOR YOUR NEW USE AND TRANSACTIONS. Any new
          Terms or Additional Terms will be effective as to new use and
          transactions as of the time that we post them, or such later date as
          may be specified in them or in other notice to you. In the event any
          notice to you of new, revised, or additional terms is determined by a
          tribunal to be insufficient, the prior agreement shall continue until
          sufficient notice to establish a new agreement occurs. You can reject
          any new, revised or additional terms by discontinuing use of the
          Service.
        </p>
        <h1 className="text-xl font-bold text-primary">
          12. GENERAL PROVISIONS.
        </h1>
        <p>
          <strong>A. PWR Network Limited.’s Consent or Approval.</strong>As to
          any provision in these Terms or any applicable Additional Terms that
          grants PWR Network Limited a right of consent or approval, or permits
          PWR Network Limited to exercise a right in its “sole discretion,” PWR
          Network Limited may exercise that right in its sole and absolute
          discretion. No consent or approval may be deemed to have been granted
          by PWR Network Limited without being in writing and signed by an
          officer of PWR Network Limited.
        </p>
        <p>
          <strong>B. Indemnity.</strong>As permitted by applicable law, you
          agree to, and you hereby, defend (if requested by PWR Network
          Limited), indemnify, and hold Company Parties harmless from and
          against any and all claims, damages, losses, costs, investigations,
          liabilities, judgments, fines, penalties, settlements, interest, and
          expenses (including attorneys’ fees) that directly or indirectly arise
          from or are related to any claim, suit, action, demand, or proceeding
          made or brought against any Company Party, or on account of the
          investigation, defense, or settlement thereof, arising out of or in
          connection with: (i) your UGC; (ii) your use of the Service and your
          activities in connection with the Service; (iii) your breach or
          alleged breach of these Terms or any applicable Additional Terms; (iv)
          your violation or alleged violation of any laws, rules, regulations,
          codes, statutes, ordinances, or orders of any governmental or
          quasi-governmental authorities in connection with your use of the
          Service or your activities in connection with the Service; (v)
          information or material transmitted through your Device, even if not
          submitted by you, that infringes, violates, or misappropriates any
          copyright, trademark, trade secret, trade dress, patent, publicity,
          privacy, or other right of any person or entity; (vi) any
          misrepresentation made by you; and (vii) Company Parties’ use of the
          information that you submit to us (including your UGC) subject to our
          Privacy Statement (all of the foregoing, “Claims and Losses”). You
          will cooperate as fully required by Company Parties, in the defense of
          any Claim and Losses. Notwithstanding the foregoing, Company Parties
          retain the exclusive right to settle, compromise, and pay any and all
          Claims and Losses. Company Parties reserve the right to assume the
          exclusive defense and control of any Claims and Losses. You will not
          settle any Claims and Losses without, in each instance, the prior
          written consent of an officer of a Company Party. This section is not
          intended to limit any causes of action against us that you may have
          but are not waivable under applicable law.
        </p>
        <p>
          <strong>C. Operation of Service.</strong>PWR Network Limited makes no
          representation that the Service is appropriate or available for use
          beyond the U.S.A. If you use the Service from other locations, you are
          doing so on your own initiative and responsible for compliance with
          applicable local laws regarding your online conduct and acceptable
          content, if and to the extent local laws apply.
        </p>
        <p>
          <strong>D. Export Controls.</strong>You are responsible for complying
          with all applicable trade regulations and laws both foreign and
          domestic. Except as authorized by U.S. law, you agree and warrant not
          to export or re-export the software to any county, or to any person,
          entity, or end-user subject to U.S. export controls or sanctions.
        </p>
        <p>
          <strong>E. Severability; Interpretation.</strong>If any provision of
          these Terms, or any applicable Additional Terms, is for any reason
          deemed invalid, unlawful, void, or unenforceable by a court or
          arbitrator of competent jurisdiction, then that provision will be
          deemed severable from these Terms or the applicable Additional Terms,
          and the invalidity of the provision will not affect the validity or
          enforceability of the remainder of these Terms or the applicable
          Additional Terms. To the extent permitted by applicable law, you agree
          to waive and will waive, any applicable statutory and common law that
          may permit a contract to be construed against its drafter.
        </p>
        <p>
          <strong>
            F. Investigations;Cooperation with Law Enforcement; Termination;
            Survival.
          </strong>
          As permitted by applicable law, PWR Network Limited reserves the
          right, without limitation, to: (i) investigate any suspected breaches
          of its Service security or its information technology or other systems
          or networks, (ii) investigate any suspected breaches of these Terms
          and any applicable Additional Terms, (iii) use any information
          obtained by PWR Network Limited in accordance with its Privacy
          Statement in connection with reviewing law enforcement databases or
          complying with applicable laws and use and/or disclose any information
          obtained by PWR Network Limited to comply with law enforcement
          requests or legal requirements in accordance our Privacy Statement,
          (iv) involve and cooperate with law enforcement authorities in
          investigating any of the foregoing matters, (v) prosecute violators of
          these Terms and any applicable Additional Terms, and (vi) discontinue
          the Service, in whole or in part, or, suspend or terminate your access
          to it, in whole or in part, including any user accounts or
          registrations, at any time, without notice, for any reason and without
          any obligation to you or any third-party. Any suspension or
          termination will not affect your obligations to PWR Network Limited
          under these Terms or any applicable Additional Terms. Upon suspension
          or termination of your access to the Service, or upon notice from PWR
          Network Limited, all rights granted to you under these Terms or any
          applicable Additional Terms will cease immediately, and you agree that
          you will immediately discontinue use of the Service. The provisions of
          these Terms and any applicable Additional Terms, which by their nature
          should survive your suspension or termination will survive, including
          the rights and licenses you grant to PWR Network Limited in these
          Terms, as well as the indemnities, releases, disclaimers, and
          limitations on liability and the provisions regarding jurisdiction,
          choice of law, no class action, and mandatory arbitration.
        </p>
        <p>
          <strong>G. Assignment.</strong>PWR Network Limited may assign its
          rights and obligations under these Terms and any applicable Additional
          Terms, in whole or in part, to any party at any time without any
          notice. These Terms and any applicable Additional Terms may not be
          assigned by you, and you may not delegate your duties under them,
          without the prior written consent of an officer of PWR Network
          Limited.
        </p>
        <p>
          <strong>H. Complete Agreement; No Waiver.</strong>These Terms, and any
          applicable Additional Terms, reflect our complete agreement regarding
          the Service and supersede any prior agreements, representations,
          warranties, assurances or discussion related to the Service. Except as
          expressly set forth in these Terms or any applicable Additional Terms,
          (i) no failure or delay by you or PWR Network Limited in exercising
          any of rights, powers, or remedies under will operate as a waiver of
          that or any other right, power, or remedy, and (ii) no waiver or
          modification of any term of these Terms or any applicable Additional
          Terms will be effective unless in writing and signed by the party
          against whom the waiver or modification is sought to be enforced.
        </p>
        <p>
          Persons under 18 years of age are not permitted to use the Service.
          Nonetheless, any user under the age of eighteen (18) who have
          impermissibly registered to use the Service, and who have posted
          content or information on the Service, can request that such
          information be removed from the Service by contacting us at the email
          or address set forth in Section 8 making such a request, stating that
          they personally posted such content or information and detailing where
          the content or information is posted. We will make reasonable good
          faith efforts to remove the post from prospective public view or
          anonymize it so the minor cannot be individually identified. This
          removal process cannot ensure complete or comprehensive removal. For
          instance, third-parties may have republished the post and archived
          copies of it may be stored by search engines and others that we do not
          control.
        </p>
        <p>
          California residents should visit our Privacy Statement to learn more
          about their California privacy rights.
        </p>
        <h1 className="text-xl font-bold text-primary">
          13. CANCELLATION, REFUND AND RETURN POLICY
        </h1>
        <p>
          At any time and without cause, membership to the website may be
          terminated by either the website or the user upon notification to the
          other party by electronic mail. When the member requests the
          termination, existing coin balance is NOT refunded. Users are liable
          for charges incurred by them until termination of service. Any refunds
          can only be made to the same card number or bank account that was used
          to place the original order. If you need to cancel your order, you
          should contact our website through the email contact form. Please make
          sure to include your user name, your real name, email address and
          phone number. Should you encounter any difficulties with the
          cancellation of your order, please contact us at hello@flirtybum.com
          but please make sure you have your personal information at hand,
          including: account name, real name, email address, phone number and
          order number in xxxxxx.yyyyyyy format, i.e. 999994.1234567 which you
          will find in the order confirmation email you would have received
          after you completed the checkout process.
        </p>
        <h1 className="text-xl font-bold text-primary">14. Credits</h1>
        <p>
          Users may send unlimited amount of messages if they purchase the
          unlimited plan for a set amount of time. Users can also purchase
          credits through various package sizes. Each message that is sent will
          deduct 7 credits from the users overall total.
        </p>
        <p>
          statement concerning infringement of intellectual property rights
          (such as Digital Millennium Copyright Act (DMCA) Notice and Takedown
          policy) Although our website (“Site”) is not based in the United
          States, we respect the intellectual property rights of copyright
          holders, and thus have chosen to voluntarily comply with the Notice
          and Takedown provisions of the Digital Millennium Copyright Act
          (“DMCA”). This Site qualifies as a “Service Provider” within the
          meaning of 17 U.S.C. § 512(k)(1) of the DMCA. Accordingly, it is
          entitled to certain protections from claims of copyright infringement
          under the DMCA, commonly referred to as the “safe harbor” provisions.
          We respect the intellectual property of others, and we ask our users
          to do the same. Thus, we observe and comply with the DMCA, and have
          adopted the following Notice and Takedown Policy relating to claims of
          copyright infringement by our customers, subscribers or users.
        </p>
        <SiteDeclaration />
      </div>
    </InnerView>
  );
}
